import { ChangeDetectorRef, Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { CommonSandbox } from 'src/core/common/common.sandbox';
import { TagModel } from 'src/core/common/models/tag.model';
import { MessageService } from 'src/core/services/messages.service';
import { PromtDialogComponent } from '../promt-dialog/promt.dialog';

@Component({
    templateUrl: './tags.dialog.html',
    styleUrls: ['./tags.dialog.scss']
})
export class TagsDialogComponent implements OnInit, OnDestroy {
    private subs: Subscription[] = [];

    value = '';
    availableTags: TagModel[] = [];
    filteredTags: TagModel[] = [];

    constructor(
        @Inject(MAT_DIALOG_DATA) data: any,
        private commonSandbox: CommonSandbox,
        private message: MessageService,
        private cd: ChangeDetectorRef,
        private dialogRef: MatDialogRef<TagsDialogComponent>,
        private dialog: MatDialog
    ) { }

    ngOnInit(): void {
        this.getTagList();

        this.subs.push(this.commonSandbox.getTagListData$.subscribe(res => {
            if (res) {
                this.availableTags = res;
                this.filterTag();
            }
        }));
        this.subs.push(this.commonSandbox.getTagListFailData$.subscribe(res => {
            if (res) {
                this.message.log('Server error!');
            }
        }));
        this.subs.push(this.commonSandbox.createTagItemData$.subscribe(res => {
            if (res) {
                this.getTagList();
            }
        }));
        this.subs.push(this.commonSandbox.createTagItemFailData$.subscribe(res => {
            if (res) {
                this.value = '';
                this.message.log('Server error!');
            }
        }));
        this.subs.push(this.commonSandbox.removeTagItemData$.subscribe(res => {
            if (res) {
                this.value = '';
                this.message.log('Tag removed!');
                this.getTagList();
            }
        }));
        this.subs.push(this.commonSandbox.removeTagItemFailData$.subscribe(res => {
            if (res) {
                this.value = '';
                this.message.log('Server error!');
            }
        }));
    }

    clear(): void {
        this.value = '';
        this.filterTag();
    }


    private getTagList(): void {
        this.commonSandbox.doGetTagList({});
    }

    public filterTag(e: any = 0): void {
        if (this.value) {
            this.filteredTags = this.availableTags.filter(el => el.value.toLocaleLowerCase().indexOf(this.value.toLocaleLowerCase()) >= 0);
        } else {
            this.filteredTags = this.availableTags;
        }
        this.cd.markForCheck();
    }

    addTag(): void {
        if (!this.value) {
            return;
        }
        this.commonSandbox.doCreateTagItem({
            value: this.value,
            description: ''
        })
    }

    removeTag(tag: TagModel): void {
        this.dialog.open(PromtDialogComponent).afterClosed().subscribe(res => {
            if (res) {
                this.commonSandbox.doRemoveTagItem(tag.id);
            }
        })
    }

    selectTag(tag: TagModel): void {
        this.dialogRef.close(tag);
    }

    ngOnDestroy(): void {
        this.subs.map(s => s.unsubscribe());
    }
}

